export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-08.8c7598e2.jpg";